// import { useState } from 'react';
// import {
//   Table,
//   TableBody,
//   Paper,
//   Box,
//   TableRow,
//   TableCell,
// } from '@mui/material';
// import Pagination from '@mui/material/Pagination';
// import Stack from '@mui/material/Stack';
// import UserTableHead from './UserTableHead';
// import UserRow from './UserRow';

// function UserTable({ users = [], onEdit, onDelete, onRowClick }) {
//   const rowsPerPage = 10;
//   const [page, setPage] = useState(1);

//   const pageCount = Math.ceil(users.length / rowsPerPage);

//   const handleChange = (_, value) => setPage(value);

//   const start = (page - 1) * rowsPerPage;
//   const paginated = users.slice(start, start + rowsPerPage);

//   const emptyRows =
//     page > 0 ? Math.max(0, rowsPerPage - paginated.length) : 0;

//   return (
//     <Box sx={{ width: '100%' }}>
//       <Paper
//         variant="outlined"
//         sx={{
//           border: '1px solid #e0e0e0',
//           borderRadius: 1,
//           minWidth: { xs: 600, sm: 'auto' },
//         }}
//       >
//         <Table size="small" sx={{ minWidth: 600 }}>
//           <UserTableHead />
//           <TableBody>
//             {paginated.map((u, idx) => (
//               <UserRow
//                 key={idx}
//                 user={u}
//                 onEdit={onEdit}
//                 onDelete={onDelete}
//                 onRowClick={onRowClick}
//               />
//             ))}

//             {emptyRows > 0 && (
//               <TableRow style={{ height: 53 * emptyRows }}>
//                 <TableCell colSpan={99} />
//               </TableRow>
//             )}
//           </TableBody>
//         </Table>

//         {/* ---- Pagination) ---- */}
//         <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
//           <Pagination
//             count={pageCount}
//             page={page}
//             onChange={handleChange}
//             sx={{
//               // active page
//               '& .Mui-selected': {
//                 backgroundColor: '#6366F1 !important',
//                 color: '#fff',
//               },

//             }}
//           />
//         </Box>
//       </Paper>
//     </Box>
//   );
// }

// export default UserTable;

// import { useState,useEffect } from 'react';
// import {
//   Table,
//   TableBody,
//   Paper,
//   Box,
//   TableRow,
//   TableCell,
//   Typography,
// } from '@mui/material';
// import Pagination from '@mui/material/Pagination';
// import UserTableHead from './UserTableHead';
// import UserRow from './UserRow';
// import NoData from "../../../../components/NoData"

// function UserTable({ users = [], onEdit, onDelete, onRowClick }) {

//   const rowsPerPage = 10;
//   const [page, setPage] = useState(1);

//   const pageCount = Math.ceil(users.length / rowsPerPage);
//   const handleChange = (_, value) => setPage(value);

//   const start = (page - 1) * rowsPerPage;
//   const paginated = users.slice(start, start + rowsPerPage);

//   const emptyRows = page > 0 ? Math.max(0, rowsPerPage - paginated.length) : 0;

//   /* ---- empty state ---- */
//   if (users.length === 0) {
//     return (
//       <NoData/>
//     );
//   }

// return (
//   <Box sx={{ width: '100%' }}>
//     <Paper
//       variant="outlined"
//       sx={{
//         border: '1px solid #e0e0e0',
//         borderRadius: 1,
//         overflow: 'hidden',
//       }}
//     >

//       <Box sx={{ overflowX: 'auto' }}>
//         <Table size="small" sx={{ minWidth: 700 }}>
//           <UserTableHead />
//           <TableBody>
//             {paginated.map((u) => (
//               <UserRow
//                 key={u.agentId}
//                 user={u}
//                 onEdit={onEdit}
//                 onDelete={onDelete}
//                 onRowClick={onRowClick}
//               />
//             ))}

//             {emptyRows > 0 && (
//               <TableRow style={{ height: 53 * emptyRows }}>
//                 <TableCell colSpan={99} />
//               </TableRow>
//             )}
//           </TableBody>
//         </Table>
//       </Box>

//       {/* ---- Pagination ---- */}
//       <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
//         <Pagination
//           count={pageCount}
//           page={page}
//           onChange={handleChange}
//           sx={{
//             '& .Mui-selected': {
//               backgroundColor: '#6366F1 !important',
//               color: '#fff',
//             },
//           }}
//         />
//       </Box>
//     </Paper>
//   </Box>
// );
// }

// export default UserTable;

// import React, { useState, useEffect } from "react";
// import moment from "moment";
// import {
//   Box,
//   Paper,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Typography,
//   Chip,
//   IconButton,
//   Avatar,
//   Switch,
//   Fade,
//   Pagination,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   Button,
//   DialogActions,
// } from "@mui/material";
// import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import AgentIcon from "@mui/icons-material/Headphones";
// import ManagerIcon from "@mui/icons-material/Badge";
// import AdminIcon from "@mui/icons-material/AdminPanelSettings";
// import SuperAdminIcon from "@mui/icons-material/SupervisorAccount";
// import NoData from "../../../../components/NoData";
// import Loader from "../../../../components/AnimatedLoader";

// /* ---------- role helpers ---------- */
// const rolePalette = {
//   Agent: { bg: "#0891B2", icon: <AgentIcon /> },
//   Manager: { bg: "#2563EB", icon: <ManagerIcon /> },
//   Admin: { bg: "#D97706", icon: <AdminIcon /> },
//   SuperAdmin: { bg: "#BE185D", icon: <SuperAdminIcon /> },
// };

// /* ---------- single component ---------- */
// function UserTable({
//   users = [],
//   loading = false, //
//   onEdit,
//   onDelete,
//   page: pageProp = 1,
//   onPageChange,
//   rowsPerPage = 10,
// }) {
//   console.log(users, "user");

//   const [openDelete, setOpenDelete] = useState(false);
//   const [selectedId, setSelectedId] = useState(null);

//   const handleOpenDelete = (e, id) => {
//     e.stopPropagation();
//     setSelectedId(id);
//     setOpenDelete(true);
//   };

//   const handleCloseDelete = () => {
//     setOpenDelete(false);
//     setSelectedId(null);
//   };

//   const handleConfirmDelete = () => {
//     if (selectedId) {
//       onDelete?.(selectedId);
//     }
//     handleCloseDelete();
//   };

//   /* ---------- pagination ---------- */
//   const [page, setPage] = useState(pageProp);
//   useEffect(() => setPage(pageProp), [pageProp]);

//   const pageCount = Math.ceil(users.length / rowsPerPage);
//   const handleChange = (e, value) => {
//     setPage(value);
//     onPageChange?.(e, value);
//   };
//   const start = (page - 1) * rowsPerPage;
//   const paginated = users?.slice(start, start + rowsPerPage);
//   const emptyRows = Math.max(0, rowsPerPage - paginated.length);

//   /* ---------- active map ---------- */
//   const [activeMap, setActiveMap] = useState({});
//   useEffect(() => {
//     const map = {};
//     users.forEach((u) => (map[u?.agentId] = u?.isActive));
//     setActiveMap(map);
//   }, [users]);

//   const toggleActive = (id) => setActiveMap((p) => ({ ...p, [id]: !p[id] }));

//   /* ---------- header cells ---------- */
//   const headers = ["User", "Role", "Last Login", "Created", "Actions"];

//   return (
//     <Box sx={{ width: "100%" }}>
//       <Paper
//         variant="outlined"
//         sx={{
//           border: "1px solid #e0e0e0",
//           borderRadius: 1,
//           overflow: "hidden",
//           mt: 1,
//         }}
//       >
//         <Box sx={{ overflowX: "auto" }}>

//           <Table size="small" sx={{ minWidth: 700 }}>
//             <TableHead>
//               <TableRow>
//                 {headers?.map((h) => (
//                   <TableCell
//                     key={h}
//                     sx={{
//                       fontWeight: 600,
//                       py: { xs: 1, sm: 2 },
//                       color: "text.primary",
//                       borderBottom: "1px solid #e0e0e0",
//                       fontSize: { xs: 12, sm: 14 },
//                       minWidth: 80,
//                     }}
//                   >
//                     <Typography
//                       fontWeight={600}
//                       variant="body2"
//                       sx={{ fontSize: { xs: 12, sm: 14 } }}
//                     >
//                       {h}
//                     </Typography>
//                   </TableCell>
//                 ))}
//                 <TableCell
//                   sx={{ borderBottom: "1px solid #e0e0e0", width: 48 }}
//                 />
//               </TableRow>
//             </TableHead>

//             <TableBody>

//               {!loading && users.length === 0 && (
//                 <TableRow>
//                   <TableCell
//                     colSpan={99}
//                     sx={{ border: 0, p: 0, height: 53 * rowsPerPage }}
//                   >
//                     <Box
//                       sx={{
//                         height: "100%",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",

//                       }}
//                     >
//                       <NoData />
//                     </Box>
//                   </TableCell>
//                 </TableRow>
//               )}

//               {/* DATA */}
//               {!loading &&
//                 paginated.map((user) => {
//                   const initials = `${user.firstName[0]}`.toUpperCase();
//                   const roleCfg = rolePalette[user.role] || rolePalette.Agent;

//                   return (
//                     <Fade in key={user.agentId}>
//                       <TableRow
//                         hover
//                         sx={{ "&:hover": { bgcolor: "#fafafa" } }}
//                       >
//                         {/* ----  User ---- */}
//                         <TableCell sx={{ py: 1 }}>
//                           <Box
//                             display="flex"
//                             alignItems="center"
//                             gap={{ xs: 1, sm: 1.5 }}
//                           >
//                             <Avatar
//                               sx={{
//                                 width: { xs: 32, sm: 40 },
//                                 height: { xs: 32, sm: 40 },
//                                 bgcolor: "#6366F1",
//                                 fontWeight: 700,
//                               }}
//                             >
//                               {initials}
//                             </Avatar>
//                             <Box>
//                               <Typography
//                                 fontWeight={600}
//                                 fontSize={{ xs: "0.75rem", sm: "0.875rem" }}
//                               >
//                                 {user?.firstName} {user?.lastName}
//                               </Typography>
//                               <Typography
//                                 fontSize={{ xs: "0.7rem", sm: "0.75rem" }}
//                                 color="text.secondary"
//                               >
//                                 {user?.email}
//                               </Typography>
//                             </Box>
//                           </Box>
//                         </TableCell>

//                         {/* ----  Role ---- */}
//                         <TableCell sx={{ py: 1 }}>
//                           <Chip
//                             label={user?.role}
//                             size="small"
//                             sx={{
//                               color: roleCfg.bg,
//                               fontWeight: 600,
//                               height: 28,
//                               border: 1,
//                               borderColor: roleCfg.bg,
//                               backgroundColor: "transparent",
//                             }}
//                           />
//                         </TableCell>

//                         {/* ----  Last Login ---- */}
//                         <TableCell sx={{ py: 1 }}>
//                           <Typography
//                             fontSize={{ xs: "0.7rem", sm: "0.75rem" }}
//                           >
//                             {user?.lastLogin || "25 July 2025"}
//                           </Typography>
//                         </TableCell>

//                         {/* ----  Created ---- */}
//                         <TableCell sx={{ py: 1 }}>
//                           <Typography
//                             fontSize={{ xs: "0.7rem", sm: "0.75rem" }}
//                           >
//                             <Box>
//                               <Typography variant="body2" fontWeight="500">
//                                 {moment
//                                   .utc(user?.createdAt)
//                                   .format("MMM DD, YYYY")}
//                               </Typography>
//                               <Typography
//                                 variant="body2"
//                                 color="text.secondary"
//                               >
//                                 {moment.utc(user?.createdAt).format("hh:mm A")}
//                               </Typography>
//                             </Box>
//                           </Typography>
//                         </TableCell>

//                         {/* ----  Actions ---- */}
//                         <TableCell sx={{ py: 1 }}>
//                           <Box display="flex" alignItems="center" gap={1}>
//                             <IconButton
//                               size="small"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 onEdit(user);
//                               }}
//                             >
//                               <EditOutlinedIcon
//                                 style={{ color: "#F59E0B" }}
//                                 fontSize="small"
//                               />
//                             </IconButton>
//                             <IconButton
//                               size="small"
//                               // onClick={(e) => {
//                               //   e.stopPropagation();
//                               //   // onDelete?.(user.agentId);
//                               //   setOpenDelete(true);
//                               // }}
//                               onClick={(e) => handleOpenDelete(e, user.agentId)}
//                               color="error"
//                             >
//                               <DeleteOutlineIcon fontSize="small" />
//                             </IconButton>
//                             <Switch
//                               checked={activeMap[user.agentId] ?? user.isActive}
//                               onChange={(e) => {
//                                 e.stopPropagation();
//                                 toggleActive(user.agentId);
//                               }}
//                               size="small"
//                               sx={{
//                                 "& .MuiSwitch-switchBase": {
//                                   "&.Mui-checked": { color: "#6366F1" },
//                                   "&:not(.Mui-checked)": { color: "#ebebeb96" },
//                                 },
//                                 "& .MuiSwitch-track": {
//                                   backgroundColor: "gray",
//                                   opacity: 1,
//                                 },
//                               }}
//                             />
//                           </Box>
//                         </TableCell>

//                         {/* 3-dots spacer */}
//                         <TableCell sx={{ py: 1, width: 48 }} />
//                       </TableRow>
//                     </Fade>
//                   );
//                 })}

//               {emptyRows > 0 && !loading && (
//                 <TableRow style={{ height: 53 * emptyRows }}>
//                   <TableCell colSpan={99} />
//                 </TableRow>
//               )}
//             </TableBody>
//           </Table>

//         </Box>

//         {/* ---------- Pagination ---------- */}
//         <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}>
//           <Pagination
//             count={pageCount}
//             page={page}
//             onChange={handleChange}
//             sx={{
//               "& .Mui-selected": {
//                 backgroundColor: "#6366F1 !important",
//                 color: "#fff",
//               },
//             }}
//           />
//         </Box>
//         {/* delete modal */}
//         <Dialog open={openDelete} onClose={handleCloseDelete}>
//           <DialogTitle>Confirm Deletion</DialogTitle>
//           <DialogContent>
//             Are you sure you want to delete this user?
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleCloseDelete} variant="outlined">
//               Cancel
//             </Button>
//             <Button
//               onClick={handleConfirmDelete}
//               variant="contained"
//               sx={{ bgcolor: "#6366F1", color: "#fff" }}
//             >
//               Delete
//             </Button>
//           </DialogActions>
//         </Dialog>
//       </Paper>
//     </Box>
//   );
// }

// export default UserTable;

import React, { useState, useEffect } from "react";
import moment from "moment";
import {
  Box,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Chip,
  IconButton,
  Avatar,
  Switch,
  Fade,
  Pagination,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  DialogActions,
  Checkbox,
  FormControlLabel,
  CircularProgress,
  TextField,
  InputAdornment,
  Divider,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AgentIcon from "@mui/icons-material/Headphones";
import ManagerIcon from "@mui/icons-material/Badge";
import AdminIcon from "@mui/icons-material/AdminPanelSettings";
import SuperAdminIcon from "@mui/icons-material/SupervisorAccount";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import NoData from "../../../../components/NoData";
import Loader from "../../../../components/AnimatedLoader";
import axiosInstance from "../../../../services/axiosInterceptors";
import apiEndPointsConfig from "../../../../services/apiEndPoints";
import { palette, theme as colorTheme } from "../../../../Convoze.theme";



const primary = colorTheme('palette', 'primary').value;
const neutral =  colorTheme('palette', 'neutral').value;
const agent = colorTheme('palette', 'agent').value;
const superadmin = colorTheme('palette', 'superAdmin').value;

/* ---------- role helpers ---------- */
const rolePalette = {
  Agent: { bg: agent, icon: <AgentIcon /> },
  Manager: { bg: primary, icon: <ManagerIcon /> },
  Admin: { bg: neutral, icon: <AdminIcon /> },
  SuperAdmin: { bg: superadmin, icon: <SuperAdminIcon /> },
};

  

/* ---------- single component ---------- */
function UserTable({
  refresh,
  users = [],
  loading = false,
  onEdit,
  onDelete,
  page: pageProp = 1,
  onPageChange,
  rowsPerPage = 10,
}) {
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  // Assign Branch Managers modal state
  const [assignOpen, setAssignOpen] = useState(false);
  const [assignQaUser, setAssignQaUser] = useState(null);
  const [allBranchManagers, setAllBranchManagers] = useState([]);
  const [selectedBMs, setSelectedBMs] = useState([]);
  const [assignLoading, setAssignLoading] = useState(false);
  const [assignSaving, setAssignSaving] = useState(false);
  const [bmSearch, setBmSearch] = useState("");

  const openAssignDialog = async (user) => {
    setAssignQaUser(user);
    setAssignOpen(true);
    setAssignLoading(true);
    setBmSearch("");
    try {
      const token = localStorage.getItem("token");
      const res = await axiosInstance.get(
        `${apiEndPointsConfig.getAssignedBranchManagers}/${user.agentId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setAllBranchManagers(res.data?.data?.branchManagers || []);
      setSelectedBMs(res.data?.data?.assignedAgentIds || []);
    } catch (e) {
      console.error("Failed to fetch branch managers", e);
    } finally {
      setAssignLoading(false);
    }
  };

  const toggleBM = (agentId) => {
    setSelectedBMs((prev) =>
      prev.includes(agentId) ? prev.filter((x) => x !== agentId) : [...prev, agentId]
    );
  };

  const saveAssignment = async () => {
    setAssignSaving(true);
    try {
      const token = localStorage.getItem("token");
      await axiosInstance.put(
        apiEndPointsConfig.assignBranchManagers,
        { qaAgentId: assignQaUser.agentId, branchManagerAgentIds: selectedBMs },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setAssignOpen(false);
    } catch (e) {
      console.error("Failed to save assignment", e);
    } finally {
      setAssignSaving(false);
    }
  };

  const handleOpenDelete = (e, id) => {
    e.stopPropagation();
    setSelectedId(id);
    setOpenDelete(true);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setSelectedId(null);
  };

  const handleConfirmDelete = () => {
    if (selectedId) onDelete?.(selectedId);
    handleCloseDelete();
  };

  const toggleStatus = async (user, statusToChange) => {
    console.log("Inside Toggle status function ");
    const token = localStorage.getItem("token");
    if (!token) return alert("Token is not present..");
    const body = {
      ...user,
      employeeId: user?.agentId,
      status: statusToChange,
    };
    try {
      const res = await axiosInstance.put(
        apiEndPointsConfig?.updateUser,
        body,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (res?.data?.status?.code == 200) {
        refresh();
        console.log("toggleStatus response:", res?.data);
      }
    } catch (err) {
      alert("Failed to update status");
      console.error("toggleStatus error:", err);
    }
  };

  /* ---------- pagination ---------- */
  const [page, setPage] = useState(pageProp);
  useEffect(() => setPage(pageProp), [pageProp]);

  const pageCount = Math.ceil(users.length / rowsPerPage);
  const handleChange = (e, value) => {
    setPage(value);
    onPageChange?.(e, value);
  };
  const start = (page - 1) * rowsPerPage;
  const paginated = users?.slice(start, start + rowsPerPage) ?? [];
  const emptyRows = Math.max(0, rowsPerPage - paginated.length);

  const headers = ["User", "Role", "Last Login", "Created", "Actions"];





  if (loading) {
    return (
      <Box
        sx={{
          width: "100%",
          height: 480,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        
        }}
      >
        <Loader />
      </Box>
    );
  }

  if (users.length === 0) {
    return (
      <Box
        sx={{
          width: "100%",
          height: 480,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <NoData />
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%"}}>
      
      <Paper
        variant="outlined"
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: 1,
          overflow: "hidden",
          mt: 1,
        }}
      >
        <Box sx={{ overflowX: "auto"}}>
          <Table size="small" sx={{ minWidth: 700 }}>
            <TableHead>
              <TableRow>
                {headers.map((h) => (
                  <TableCell
                    key={h}
                    sx={{
                      fontWeight: 600,
                      py: { xs: 1, sm: 2 },
                      color: "text.primary",
                      borderBottom: "1px solid #e0e0e0",
                      fontSize: { xs: 12, sm: 14 },
                      minWidth: 80,
                    }}
                  >
                    <Typography
                      fontWeight={600}
                      variant="body2"
                      sx={{ fontSize: { xs: 12, sm: 14 } }}
                    >
                      {h}
                    </Typography>
                  </TableCell>
                ))}
                <TableCell
                  sx={{ borderBottom: "1px solid #e0e0e0", width: 48 }}
                />
              </TableRow>
            </TableHead>

            <TableBody>
              {paginated.map((user) => {
                const initials = `${user.firstName[0]}`.toUpperCase();
                const roleCfg = rolePalette[user?.role] || rolePalette?.Agent;

                return (
                  <Fade in key={user.agentId}>
                    <TableRow hover sx={{ "&:hover": { bgcolor: "#fafafa" } }}>
                      {/* ----  User ---- */}
                      <TableCell sx={{ py: 1 }}>
                        <Box
                          display="flex"
                          alignItems="center"
                          gap={{ xs: 1, sm: 1.5 }}
                        >
                          <Avatar
                            sx={{
                              width: { xs: 32, sm: 40 },
                              height: { xs: 32, sm: 40 },
                              // bgcolor: "#6366F1",
                              bgcolor : primary,
                              fontWeight: 700,
                            }}
                          >
                            {initials}
                          </Avatar>
                          <Box>
                            <Typography
                              fontWeight={600}
                              fontSize={{ xs: "0.75rem", sm: "0.875rem" }}
                            >
                              {user?.firstName} {user?.lastName}
                            </Typography>
                            <Typography
                              fontSize={{ xs: "0.7rem", sm: "0.75rem" }}
                              color="text.secondary"
                            >
                              {user?.email}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>

                      {/* ----  Role ---- */}
                      <TableCell sx={{ py: 1 }}>
                        <Chip
                          label={user.role}
                          size="small"
                          sx={{
                            color: roleCfg.bg,
                            fontWeight: 600,
                            height: 28,
                            border: 1,
                            borderColor: roleCfg.bg,
                            backgroundColor: "transparent",
                          }}
                        />
                      </TableCell>

                      {/* ----  Last Login ---- */}
                      <TableCell sx={{ py: 1 }}>
                        <Typography fontSize={{ xs: "0.7rem", sm: "0.75rem" }}>
                          {user?.lastLogin || "25 July 2025"}
                        </Typography>
                      </TableCell>

                      {/* ----  Created ---- */}
                      <TableCell sx={{ py: 1 }}>
                        <Typography fontSize={{ xs: "0.7rem", sm: "0.75rem" }}>
                          <Box>
                            <Typography variant="body2" fontWeight="500">
                              {moment
                                .utc(user?.createdAt)
                                .format("MMM DD, YYYY")}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {moment.utc(user?.createdAt).format("hh:mm A")}
                            </Typography>
                          </Box>
                        </Typography>
                      </TableCell>

                      {/* ----  Actions ---- */}
                      <TableCell sx={{ py: 1 }}>
                        <Box display="flex" alignItems="center" gap={1}>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              onEdit(user);
                            }}
                          >
                            <EditOutlinedIcon
                              style={{ color: neutral }}
                              fontSize="small"
                            />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={(e) => handleOpenDelete(e, user?.agentId)}
                            color="error"
                          >
                            <DeleteOutlineIcon fontSize="small" />
                          </IconButton>
                          {user?.role === "QualityAnalyst" && (
                            <IconButton
                              size="small"
                              title="Assign Branch Managers"
                              onClick={(e) => { e.stopPropagation(); openAssignDialog(user); }}
                              sx={{ color: primary }}
                            >
                              <GroupAddIcon fontSize="small" />
                            </IconButton>
                          )}
                          <Switch
                            checked={user.status === "active" ? true : false}
                            onChange={async (e) => {
                              e.stopPropagation();
                              await toggleStatus(
                                user,
                                user.status === "active" ? "inactive" : "active"
                              );
                            }}
                            size="small"
                            sx={{
                              "& .MuiSwitch-switchBase": {
                                "&.Mui-checked": 
                                // { color: "#6366F1" },
                                {color : primary},
                                "&:not(.Mui-checked)":
                                 { color: "#ebebeb96" },
                              },
                              "& .MuiSwitch-track": {
                                backgroundColor: "gray",
                                opacity: 1,
                              },
                            }}
                          />
                        </Box>
                      </TableCell>

                      {/* 3-dots spacer */}
                      <TableCell sx={{ py: 1, width: 48 }} />
                    </TableRow>
                  </Fade>
                );
              })}

              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={99} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>

        {/* ---------- Pagination ---------- */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}>
          <Pagination
            count={pageCount}
            page={page}
            onChange={handleChange}
            sx={{
              "& .Mui-selected": {
                backgroundColor: `${primary} !important`,
                color: "#fff",
              },
            }}
          />
        </Box>

        {/* delete modal */}
        <Dialog open={openDelete} onClose={handleCloseDelete}>
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            Are you sure you want to delete this user?
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDelete} variant="outlined">
              Cancel
            </Button>
            <Button
              onClick={handleConfirmDelete}
              variant="contained"
              sx={{ bgcolor: primary, color: "#fff" }}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        {/* Assign Branch Managers modal */}
        <Dialog
          open={assignOpen}
          onClose={() => setAssignOpen(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}
        >
          {/* Header */}
          <Box sx={{ background: `linear-gradient(135deg, ${primary} 0%, #9333ea 100%)`, px: 3, py: 2.5, position: "relative" }}>
            <IconButton
              size="small"
              onClick={() => setAssignOpen(false)}
              sx={{ position: "absolute", top: 10, right: 10, color: "#fff" }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
            <Box display="flex" alignItems="center" gap={1.5}>
              <Box sx={{ bgcolor: "rgba(255,255,255,0.2)", borderRadius: 2, p: 1, display: "flex" }}>
                <GroupAddIcon sx={{ color: "#fff", fontSize: 22 }} />
              </Box>
              <Box>
                <Typography fontWeight={700} fontSize="1rem" color="#fff">
                  Assign Branch Managers
                </Typography>
                {assignQaUser && (
                  <Typography fontSize="0.78rem" color="rgba(255,255,255,0.8)">
                    to {assignQaUser.firstName} {assignQaUser.lastName}
                  </Typography>
                )}
              </Box>
            </Box>
            {selectedBMs.length > 0 && (
              <Chip
                label={`${selectedBMs.length} selected`}
                size="small"
                icon={<CheckCircleIcon sx={{ fontSize: "14px !important", color: "#fff !important" }} />}
                sx={{ mt: 1.5, bgcolor: "rgba(255,255,255,0.25)", color: "#fff", fontWeight: 600, fontSize: "0.72rem" }}
              />
            )}
          </Box>

          <DialogContent sx={{ p: 0 }}>
            {assignLoading ? (
              <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" py={6} gap={2}>
                <CircularProgress size={32} sx={{ color: primary }} />
                <Typography fontSize="0.85rem" color="text.secondary">Loading branch managers…</Typography>
              </Box>
            ) : allBranchManagers.length === 0 ? (
              <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" py={6} gap={1}>
                <GroupAddIcon sx={{ fontSize: 40, color: "#d1d5db" }} />
                <Typography color="text.secondary" fontSize="0.875rem">No Branch Managers found in your company.</Typography>
              </Box>
            ) : (
              <>
                {/* Search + Select All */}
                <Box px={2.5} pt={2.5} pb={1.5}>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Search branch managers…"
                    value={bmSearch}
                    onChange={(e) => setBmSearch(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon fontSize="small" sx={{ color: "#9ca3af" }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, fontSize: "0.875rem" } }}
                  />
                </Box>

                <Box px={2.5} pb={1} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography fontSize="0.75rem" color="text.secondary">
                    {allBranchManagers.length} branch manager{allBranchManagers.length !== 1 ? "s" : ""}
                  </Typography>
                  <Button
                    size="small"
                    onClick={() => {
                      const filtered = allBranchManagers.filter(bm =>
                        `${bm.firstName} ${bm.lastName}`.toLowerCase().includes(bmSearch.toLowerCase())
                      );
                      const allSelected = filtered.every(bm => selectedBMs.includes(bm.agentId));
                      if (allSelected) {
                        setSelectedBMs(prev => prev.filter(id => !filtered.map(b => b.agentId).includes(id)));
                      } else {
                        setSelectedBMs(prev => [...new Set([...prev, ...filtered.map(b => b.agentId)])]);
                      }
                    }}
                    sx={{ fontSize: "0.75rem", textTransform: "none", color: primary, p: 0, minWidth: 0 }}
                  >
                    {allBranchManagers
                      .filter(bm => `${bm.firstName} ${bm.lastName}`.toLowerCase().includes(bmSearch.toLowerCase()))
                      .every(bm => selectedBMs.includes(bm.agentId))
                      ? "Deselect All" : "Select All"}
                  </Button>
                </Box>

                <Divider />

                {/* List */}
                <Box sx={{ maxHeight: 320, overflowY: "auto", px: 1.5, py: 1 }}>
                  {allBranchManagers
                    .filter(bm => `${bm.firstName} ${bm.lastName}`.toLowerCase().includes(bmSearch.toLowerCase()))
                    .map((bm) => {
                      const isChecked = selectedBMs.includes(bm.agentId);
                      const initials = `${bm.firstName?.[0] || ""}${bm.lastName?.[0] || ""}`.toUpperCase();
                      return (
                        <Box
                          key={bm.agentId}
                          onClick={() => toggleBM(bm.agentId)}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                            px: 1.5,
                            py: 1,
                            borderRadius: 2,
                            cursor: "pointer",
                            mb: 0.5,
                            bgcolor: isChecked ? `${primary}12` : "transparent",
                            border: isChecked ? `1px solid ${primary}30` : "1px solid transparent",
                            transition: "all 0.15s ease",
                            "&:hover": { bgcolor: isChecked ? `${primary}18` : "#f9fafb" },
                          }}
                        >
                          <Avatar sx={{ width: 36, height: 36, bgcolor: isChecked ? primary : "#e5e7eb", color: isChecked ? "#fff" : "#6b7280", fontSize: "0.8rem", fontWeight: 700 }}>
                            {initials}
                          </Avatar>
                          <Box flex={1}>
                            <Typography fontSize="0.875rem" fontWeight={600} color={isChecked ? primary : "text.primary"}>
                              {bm.firstName} {bm.lastName}
                            </Typography>
                            <Typography fontSize="0.72rem" color="text.secondary">
                              ID: {bm.agentId}
                            </Typography>
                          </Box>
                          <Checkbox
                            checked={isChecked}
                            onChange={() => toggleBM(bm.agentId)}
                            onClick={(e) => e.stopPropagation()}
                            size="small"
                            sx={{ "&.Mui-checked": { color: primary } }}
                          />
                        </Box>
                      );
                    })}
                </Box>
              </>
            )}
          </DialogContent>

          <Divider />
          <DialogActions sx={{ px: 2.5, py: 2, gap: 1 }}>
            <Button
              onClick={() => setAssignOpen(false)}
              variant="outlined"
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, borderColor: "#e5e7eb", color: "#374151" }}
            >
              Cancel
            </Button>
            <Button
              onClick={saveAssignment}
              variant="contained"
              disabled={assignSaving || assignLoading}
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, bgcolor: primary, px: 3, "&:hover": { bgcolor: primary } }}
            >
              {assignSaving ? <CircularProgress size={18} sx={{ color: "#fff" }} /> : "Save Changes"}
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </Box>
  );
}

export default UserTable;
